import React from 'react';
import Model from "@tripian/model";
import useTranslate from "../../../hooks/useTranslate";
import { useNavigate } from "react-router-dom";

interface TopAttractionsProps {
    cityName: string;
    attractions: Model.Poi[];
    t: (value: Model.TranslationKey) => string;
}

const AttractionCard: React.FC<{ poi: Model.Poi }> = ({ poi }) => {
    const { t } = useTranslate();
    const navigate = useNavigate();
    return (
        <div className="flex-1 flex items-center gap-4 cursor-pointer hover:opacity-80 transition-opacity"
             onClick={() => navigate(`/place/${poi.id}`)}>
            <div className="w-24 h-24 bg-gray-200 rounded-lg overflow-hidden">
                {poi.image?.url && (
                    <img
                        src={poi.image.url}
                        alt={poi.name}
                        className="w-full h-full object-cover"
                    />
                )}
            </div>
            <div>
                <h3 className="font-semibold mb-1 font-16-h">{poi.name}</h3>
                {poi.rating && (
                    <p className="text-gray-600 font-14-h">{t('valai.rating')} : {poi.rating.toFixed(1)}</p>
                )}
            </div>
        </div>
    );
};

const TopAttractions: React.FC<TopAttractionsProps> = ({ cityName, attractions }) => {
    const { t } = useTranslate();

    if (attractions.length === 0) return null;

    return (
        <div className="max-w-7xl mx-auto px-4 pb-12">
            <h2 className="text-2xl syne-fm text-center py-6">{t('valai.topAttractionsIn')}{cityName}</h2>
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
                {attractions.slice(0, 6).map((poi) => (
                    <AttractionCard
                        key={poi.id}
                        poi={poi}
                    />
                ))}
            </div>
        </div>
    );
};

export default TopAttractions;
